import "./css/Mailbox.css"
import GmailIcon from "../assets/icons/GmailIcon.webp"
import OutlookIcon from "../assets/icons/OutlookIcon.webp"
import GoogleIcon from "../assets/icons/GoogleIcon.webp"
import { useEffect, useState } from "react"
import api from "../config/backend"
import axios from "axios"
import { InboxOutlined } from "@mui/icons-material"
import { AiFillStar, AiOutlineStar } from "react-icons/ai"
import { useNavigate } from "react-router-dom"
import Compose from "./Compose"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"

const Mailbox = () => {
    const [signPopup, setSignPopup] = useState(false)
    const [emails, setEmails] = useState(undefined)
    const [currentPage, setCurrentPage] = useState(0)
    const [visibleEmails, setVisibleEmails] = useState(undefined)
    const [populatedEmails, setPopulatedEmails] = useState([])
    const [resultPerPage, setResultPerPage] = useState(13)
    const [totalPages, setTotalPages] = useState(0)
    const [compose, setCompose] = useState(false)
    const [username, setUsername] = useState(undefined)
    const [triggerRefresh, setTriggerRefresh] = useState(0)

    const navigate = useNavigate()

    const _crm__token = localStorage.getItem("_crm__token")
    const mailboxLinked = localStorage.getItem("mailbox-link") === "1"

    const redirectOAuth = async () => {
        const base = "https://accounts.google.com/o/oauth2/auth"

        const host = window.location.host
        const protocol = window.location.protocol

        const options = {
            redirect_uri: `${protocol}//${host}/crm/mailbox/oauth`,
            client_id: "385068629420-2j0uofiqocihisa09uheubdknkp090rn.apps.googleusercontent.com",
            access_type: "offline",
            response_type: "code",
            prompt: "consent",
            scope: [
                "https://mail.google.com/",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/userinfo.profile"
            ].join(" ")
        }

        const qs = new URLSearchParams(options)

        const link = `${base}?${String(qs)}`

        window.location.href = link
    }

    const isMailboxLinked = async () => {
        const { data, status } = await axios.post(`${api}/Mailbox/email-address`, { token: _crm__token })
        
        if (data.success) {
            localStorage.setItem("mailbox-link", "1")
            setTriggerRefresh(prev => prev + 1)
        }
    }

    const fetchEmails = async () => {
        const { data, status } = await axios.post(`${api}/Mailbox/get-emails`, { token: _crm__token })

        if (data.success) {
            setEmails(data.inbox)
            setUsername(data.email)

            if (data.resultSizeEstimate > 100) {
                setTotalPages(Math.ceil(100 / resultPerPage))
            }
            else {
                setTotalPages(Math.ceil(data.resultSizeEstimate) / resultPerPage)
            }
        }
        else {
            if (data.redirect) {
                localStorage.removeItem("mailbox-link")
                toast.info("Mailbox session expired")
                setTriggerRefresh(prev => prev + 1)
            } else {
                toast.error(data.message)
            }
        }
    }

    useEffect(() => {
        if (mailboxLinked) {
            fetchEmails()
        } 
        // Check backend if mailbox is linked
        else {
            isMailboxLinked()
        }
    }, [mailboxLinked])

    useEffect(() => {
        if (emails) {
            setVisibleEmails(emails.slice(currentPage * resultPerPage, (currentPage * resultPerPage) + resultPerPage))
        }
    }, [currentPage, emails])

    useEffect(() => {
        const read = async (id, index) => {
            const { data, status } = await axios.post(`${api}/Mailbox/read-email`, { token: _crm__token, identifier: id })

            setPopulatedEmails(prev => {
                const copy = JSON.parse(JSON.stringify(prev))

                copy[index] = data.email

                return copy
            })
        }

        if (visibleEmails) {
            setPopulatedEmails(Array.from(visibleEmails).fill(undefined))

            visibleEmails.forEach((email, index) => {
                read(email.id, index)
            })
        }
    }, [visibleEmails])

    // Mailbox oauth required
    if (mailboxLinked === false) {
        return (
            <div className="_4kos">
                <h4>Mailbox</h4>
                <div className="vitiligo-low">
                    <button onClick={() => setSignPopup(true)} className="olivary-gets">Connect my e-mail</button>
                </div>
                {signPopup ? <div className="epimeric-sly" onClick={() => setSignPopup(false)}>
                    <div className="card" onClick={e => e.stopPropagation()}>
                        <div className="header">
                            Connect your sales inbox
                        </div>
                        <div className="box">
                            <div className="row">
                                <img src={GmailIcon} alt="G-mail icon" />
                                <div className="g_mail">
                                    Gmail Account
                                </div>
                                <div className="requites-toe" onClick={() => redirectOAuth()}>
                                    <div className="riffs-harm">
                                        <img src={GoogleIcon} alt="Google icon" />
                                    </div>
                                    <span className="g_mail">Sign in with Google</span>
                                </div>
                            </div>
                            <div className="row">
                                <img src={OutlookIcon} alt="G-mail icon" />
                                <div className="g_mail">
                                    Outlook Account
                                </div>
                                <div className="requites-toe">
                                    <span className="g_mail">Sign in with Outlook</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : undefined}
            </div>
        )
    }

    console.log({ populatedEmails })

    const isLoading = populatedEmails.filter(item => item === undefined || item === null).length > 4

    // User is logged in to mailbox
    return (
        <div className="_5qvf">
            {compose === true ? <Compose username={username} setPopup={setCompose} /> : undefined}
            <div className="dryer-saws">
                <div className="cantraps-mar">
                    <InboxOutlined />
                    <span>Inbox</span>
                </div>
                <div>
                    <button className="goofs-ows" onClick={() => setCompose(true)}>Compose</button>
                </div>
            </div>
            {isLoading ? (
                <div className="druids-ben">
                    <SpinnerCircular size="70" />
                </div>
            ) : (
                <div>
                    <div className="mustard-surf">
                        {populatedEmails.map((email, index) => {
                            if (email === undefined || email === null) {
                                return
                            }

                            const headers = email.payload.headers
                            const labels = email.labelIds

                            let subject, sender, date

                            const unread = labels.includes("UNREAD")
                            const important = labels.includes("IMPORTANT")
                            const starred = labels.includes("STARRED")

                            headers.forEach(item => {
                                if (item.name === "Subject") {
                                    subject = item.value
                                }
                                else if (item.name === "From") {
                                    sender = item.value.replace(/ <.+>/, "")
                                    sender = sender.replace(/(^"|"$)/g, '')
                                }
                                else if (item.name === "Date") {
                                    date = item.value
                                }
                            })

                            return (
                                <div key={index} onClick={() => navigate(`/mailbox/read/${email.id}`)} className={unread ? "stoked-mare unread" : "stoked-mare"}>
                                    <div className="serrying-cur">
                                        <AiFillStar className={starred ? "starred" : undefined} />
                                    </div>
                                    <div className="sender">
                                        {sender}
                                    </div>
                                    <div className="content">
                                        {subject}
                                        {important ? <div className="miters-pot">Important</div> : undefined}
                                    </div>
                                    <div className="date">
                                        {new Date(date).toDateString()}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
            <div className="skied-bunk">
                {Array(totalPages).fill(undefined).map((item, index) => {
                    return <button key={index} className={index === currentPage ? "active" : undefined} onClick={() => setCurrentPage(index)}>{index + 1}</button>
                })}
            </div>
        </div>
    )
}

export default Mailbox
